import { render } from "./WindowPhoto.vue?vue&type=template&id=02546e8f&scoped=true"
import script from "./WindowPhoto.vue?vue&type=script&lang=js"
export * from "./WindowPhoto.vue?vue&type=script&lang=js"

import "./WindowPhoto.vue?vue&type=style&index=0&id=02546e8f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-02546e8f"

export default script